import * as types from '../constants/ActionTypes';

// reducer with initial state
const initialState = {
    error: null,
    loader: true,
    lpError: null
};

export function errorReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_EXCEPTION:
            return {...state,
                error: action.payload
            };
        case types.SET_LOADER:
            return {...state,
                loader: action.payload
            };
        case types.SET_LP_EXCEPTION:
            return {...state,
                lpError: action.payload
            };
        default:
            return state;
    }
}
